import type { OnDestroy, OnInit } from '@angular/core';
import { Directive, TemplateRef } from '@angular/core';
import { Sidebar } from './sidebar.service';

@Directive({ selector: '[flSidebarCustom]' })
export class SidebarCustomTemplateDirective implements OnInit, OnDestroy {
  constructor(
    private templateRef: TemplateRef<any>,
    private sidebar: Sidebar,
  ) {}

  ngOnInit(): void {
    this.sidebar.setCustomTemplate(this.templateRef);
  }

  ngOnDestroy(): void {
    this.sidebar.setCustomTemplate(undefined);
  }
}
